import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ui-deprecated-monitor-warning-banner',
    imports: [RouterLink, TranslateModule],
    templateUrl: './deprecated-monitor-warning-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
// TODO: remove this component after 28.02.2025 #16015
export class DeprecatedMonitorWarningBannerComponent {}
